<template>
  <NuxtLoadingIndicator />

  <nav class="w-full bg-white border-b border-grayborder">
    <div class="px-3 py-3 lg:px-5 lg:pl-3">
      <div class="flex items-center justify-between">
        <div class="flex items-center justify-start">
          <button
            data-drawer-target="logo-sidebar"
            data-drawer-toggle="logo-sidebar"
            aria-controls="logo-sidebar"
            type="button"
            class="inline-flex items-center p-2 text-sm text-gray-500 rounded-lg lg:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200"
          >
            <span class="sr-only">Open sidebar</span>
            <svg
              class="w-6 h-6"
              aria-hidden="true"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                clip-rule="evenodd"
                fill-rule="evenodd"
                d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"
              ></path>
            </svg>
          </button>
          <nuxt-link to="/" class="flex ml-2 md:mr-24">
            <span
              class="self-center primary text-xl font-semibold sm:text-2xl whitespace-nowrap"
            >
              <img src="/ooadmin.png" class="h-[45px]" />
            </span>
          </nuxt-link>
        </div>

        <UserMenu />
      </div>
    </div>
  </nav>
  <div class="">
    <slot />
  </div>
</template>

<script setup></script>

<style lang="scss" scoped></style>
